<template>
  <div>
    <div class="form-title" v-if="loginType === 1">
      <div class="title"><span>账号登录</span></div>
      <FromInput />
    </div>
    <div class="form-title" v-else-if="loginType === 2">
      <div class="title"><span>手机登录</span></div>
      <MFromInput />
    </div>
    <div class="form-title" v-else>
      <QRLogin />
    </div>

    <!-- 记住状态/注册/忘记密码 -->
    <div class="pass_state" v-if="loginType === 1 || loginType === 2">
      <div class="pass_state_lt">
        <el-checkbox v-model="checked">记住登录状态</el-checkbox>
      </div>
      <div class="pass_state_rt">
        <el-link @click="btnClick($event)" :underline="false"
          >注册新用户</el-link
        >
        <el-link @click="btnClick($event)" :underline="false"
          >忘记密码？</el-link
        >
      </div>
    </div>

    <!-- 其他登录方式 -->
    <el-divider><span>其他登录方式</span></el-divider>

    <div class="login-action">
      <!-- 微信登录 -->
      <div
        class="login-common"
        @click="changeLoginType(3)"
        v-if="loginType !== 3"
      >
        <div class="Imagbg-setting">
          <el-image :src="WechatLoginURL"></el-image>
        </div>
        <div class="tip-content">微信登录</div>
      </div>
      <!-- 账号登录 -->
      <div
        class="login-common"
        v-if="loginType !== 1"
        @click="changeLoginType(1)"
      >
        <div class="Imagbg-setting">
          <el-image :src="AccountLoginURL"></el-image>
        </div>
        <div class="tip-content">账号登录</div>
      </div>
      <!-- 手机登录 -->
      <div
        class="login-common"
        v-if="loginType !== 2"
        @click="changeLoginType(2)"
      >
        <div class="Imagbg-setting">
          <el-image :src="PhoneLoginURL"></el-image>
        </div>
        <div class="tip-content">手机登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import FromInput from "./FromInput";
import MFromInput from "./MFromInput";
import QRLogin from "./QRLogin";

export default {
  name: "LoginPage",
  data() {
    return {
      WechatLoginURL: require("@/assets/img/login/Sign_weixin.png"),
      PhoneLoginURL: require("@/assets/img/login/Sign_phone.png"),
      AccountLoginURL: require("@/assets/img/login/Sign_account.png"),
      checked: false,
      loginType: 3,
    };
  },
  watch: {
    checked(newVal, oldVal) {
      this.$bus.loginChecked = newVal;
    },
  },

  methods: {
    handleClick(tab, event) {},
    btnClick(event) {
      let value = event.target.innerText;
      this.$emit("nameClick", value);
    },

    /**
     * @description: 切换登录方式
     * @param {*} type 1 账号登录 2 手机登录 3 微信登录
     * @return {*}
     */

    changeLoginType(type) {
      this.loginType = type;
    },
  },
  components: {
    FromInput,
    MFromInput,
    QRLogin,
  },
};
</script>

<style lang="less" scoped>
.form-title {
  .title {
    margin: 30px 0;
    span {
      font-size: 20px;
      color: #333333;
    }
  }
}
//记住状态/注册/忘记密码
.pass_state {
  display: flex;
  justify-content: space-between;
  margin-bottom: 64px;

  .pass_state_rt > a:nth-child(2) {
    margin-left: 20px;
  }

  .pass_state_rt > a {
    color: #24ba58;
  }

  /deep/.el-checkbox__inner {
    border: 1px solid #878787;
  }

  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #24ba58;
  }

  /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #24ba58;
    border-color: #24ba58;
  }
}

.el-divider--horizontal {
  width: 249px;
  margin: 19px auto;
}
.el-divider {
  span {
    color: #888888;
  }
}

.login-action {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  .login-common {
    display: flex;
    cursor: pointer;
    align-items: center;
    .tip-content {
      color: #333333;
    }
    .tip-content:hover {
      color: #24ba58;
    }
  }
  div.login-common:nth-child(1) {
    margin-right: 30px;
  }
}

.Imagbg-setting {
  width: 32px;
  height: 32px;
  background-color: #eeeeee;
  border-radius: 50%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  .el-image {
    width: 16px;
    height: 16px;
  }
}

.el-tabs {
  width: 355px;
  height: 60px;
  position: absolute;
  top: 39px;
  left: 30px;
  padding: 0;
  background-color: #fff;

  /deep/.el-tabs__header {
    margin: 0 0 40px;
  }

  /deep/.el-tabs__item:hover {
    color: #24ba58;
  }

  /deep/.el-tabs__item {
    font-size: 20px;
  }
}

//修改tab样式···················
/deep/.el-tabs__item.is-active {
  color: #24ba58;
}

/deep/.el-tabs__active-bar {
  background-color: #24ba58;
}
</style>
